import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { ensureProtocolInWebsiteUrl } from '../../../../utils/helpers';
import { phoneWithInternationalCode } from '../../../../utils/helpers/common';
import { Modal } from '../../../ui/Modal';
import {
  ContactEmail,
  ContactsModalContainer,
  ContactWebsite,
  headerStyles,
  LinksContainer,
  modalStyles,
  PhoneLink
} from './styled';
import { BackButtonIconEnum } from '../../../ui/PageHeader/types';

interface ContactsModalProps {
  isOpen: boolean;
  onClose: () => void;
  phonesShown: string[];
  contactEmail?: string;
  website?: string;
}

export const ContactsModal: React.FC<ContactsModalProps> = memo(
  ({ phonesShown, isOpen, onClose, contactEmail, website }) => {
    const { t } = useTranslation();

    return (
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        modalId="contacts"
        cypress="residence-contacts"
        modalStyles={modalStyles}
        title={t('residences.numbers')}
        headerIcon={BackButtonIconEnum.Close}
        closeButtonAlign="right"
        headerStyles={headerStyles}
      >
        <ContactsModalContainer>
          <LinksContainer>
            {phonesShown?.map((phone, i) => (
              <PhoneLink
                key={i}
                href={`tel:${phoneWithInternationalCode(phone)}`}
                data-stat="residence-phones"
              >
                {phone}
              </PhoneLink>
            ))}
          </LinksContainer>
          {contactEmail && (
            <ContactEmail
              href={`mailto:${contactEmail}`}
              data-stat="residence-email"
            >
              {contactEmail}
            </ContactEmail>
          )}
          {website && (
            <ContactWebsite
              href={ensureProtocolInWebsiteUrl(website)}
              data-stat="residence-website"
            >
              {website}
            </ContactWebsite>
          )}
        </ContactsModalContainer>
      </Modal>
    );
  }
);

ContactsModal.displayName = `ContactsModal`;
